import { useShellCreateAction } from '@ordo/ui/app-shell'
import { Badge } from '@ordo/ui/badge'
import { Button } from '@ordo/ui/button'
import { type Column, DataGrid } from 'compositions/DataGrid'
import { Page } from 'compositions/Page'
import { useInboundForwardings } from 'hooks/api/useInbound'
import { Plus } from 'lucide-react'
import { Link, useNavigate } from 'react-router'
import type { InboundForwarding } from 'types/inbound'

import { InboundError } from './inbound-shared'

const COLUMNS: Column<InboundForwarding>[] = [
  {
    key: 'phoneNumber',
    header: 'Number',
    sortable: true,
    filterable: true,
    render: (row) => (
      <Link to={`/inbound/${row.id}`} className="text-foreground hover:underline">
        {row.phoneNumber}
      </Link>
    ),
  },
  {
    key: 'audience',
    header: 'Receiving app',
    sortable: true,
    filterable: true,
  },
  {
    key: 'destinationUrl',
    header: 'Forward to URL',
    filterable: true,
    mobile: 'hidden',
  },
  {
    key: 'recognizedOnly',
    header: 'Senders',
    mobile: 'hidden',
    render: (row) => (row.recognizedOnly ? 'Recognized contacts only' : 'All senders'),
  },
  {
    key: 'active',
    header: 'Status',
    mobile: 'aside',
    render: (row) => <Badge variant={row.active ? 'secondary' : 'outline'}>{row.active ? 'Active' : 'Archived'}</Badge>,
  },
]

export function AdminInbound() {
  const navigate = useNavigate()
  const forwardings = useInboundForwardings()
  useShellCreateAction({ label: 'New Handler', onCreate: () => navigate('/inbound/new') })

  return (
    <Page>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <h1 className="text-xl font-semibold">Inbound</h1>
        <Button asChild className="hidden md:inline-flex">
          <Link to="/inbound/new">
            <Plus className="h-4 w-4" />
            New Handler
          </Link>
        </Button>
      </div>
      {forwardings.error ? <InboundError error={forwardings.error} /> : null}
      <DataGrid
        columns={COLUMNS}
        data={forwardings.data ?? []}
        keyField="id"
        pageSize={20}
        loading={forwardings.loading && !forwardings.data}
        storageKey="inbound"
        emptyMessage="No inbound handlers"
      />
    </Page>
  )
}
